import { ExamMode } from "app-layouts/ltr-layouts/Layout/components/Header/SimpleHeader";
import { TabsType } from "pages/onlineExam";
import { PAGE_SIZE } from "res/constants";
import { OnlineExamActionTypes } from "./onlineExam.types";
import { IsEqualTwoDates } from "utils/Date";

const INITAIL_STATE = {
  onlineExamData: [],
  offset: 1,
  isFetchingExams: true,
  errorFetchingExams: null,
  isLoadMore: false,
  ///GetExamDetail By ID
  // onlineExamDetailData: dataaa,
  onlineExamDetailData: undefined,
  isFetchingExamDetail: true,
  errorFetchingExamDetail: null,
  counter: undefined,
  currentQuestionIndex: 0,
  ///GetExam Result By ID
  onlineExamResultData: undefined,
  onlineExamResultWarning: null,
  isFetchingExamResult: true,
  errorFetchingExamResult: null,
  ///GetExam Answer By ID
  onlineExamAnswerData: undefined,
  isFetchingExamAnswer: true,
  errorFetchingExamAnswer: null,
  ///Post Exam
  isFetchingPostExam: false,
  errorFetchingPostExam: null,
  //Get Results
  resultData: [],
  resultOffset: 1,
  isFetchingResults: true,
  errorFetchingResults: null,
  resultLoadMore: false,
  //Options
  showNextQuestion: false,
  //currentPage
  currentPage: TabsType.exams,
  //examMode
  examMode: ExamMode.simple,

  isUploadingFile: false,
  //
  currentExamID: 0
};


function isExistExamData(state,examData,examID){
  return state.currentExamID === examID && state.onlineExamDetailData.updateDate && IsEqualTwoDates(examData.updateDate, state.onlineExamDetailData.updateDate) &&  state.onlineExamDetailData?.questionList
}

const onlineExamReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {

    case OnlineExamActionTypes.RESET_PLAN_OFFSET:
      return {
        ...state,
        offset: 1,
        onlineExamData: [],
        isLoadMore: false
      };

    case OnlineExamActionTypes.RESET_RESULT_OFFSET:
      return {
        ...state,
        resultOffset: 1,
        resultData: [],
        resultLoadMore: false
      };

    case OnlineExamActionTypes.FETCH_ONLINEEXAM_START:
      return {
        ...state,
        isFetchingExams: true,
        errorFetchingExams: null,
        counter: undefined
      };
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_SUCCESS:

      const examList = state.offset !== 1 ? [...state.onlineExamData, ...action.payload] : action.payload;
      const isLoadMore = action.payload.length >= PAGE_SIZE

      return {
        ...state,
        onlineExamData: examList,
        offset: isLoadMore ? state.offset + 1 : state.offset,
        isLoadMore: isLoadMore,
        isFetchingExams: false,
        counter: undefined

      }
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_FAILURE:
      return {
        ...state,
        isFetchingExams: false,
        errorFetchingExams: action.payload,
      };
    case OnlineExamActionTypes.RESET_ONLINEEXAM_STATE:
      return {
        ...state,
        isFetchingExams: false,
        errorFetchingExams: action.payload,
      };
    //Get Exam Result By ID
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_START:
      return {
        ...state,
        isFetchingExamResult: true,
        errorFetchingExamResult: null,
        onlineExamResultWarning: null,
        //reset Exam props
        onlineExamData: [],
        offset: 1,
        isLoadMore: false,
        //reset result props
        resultData: [],
        resultOffset: 1,
        resultLoadMore: false

      };
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_SUCCESS:

      return {
        ...state,
        onlineExamResultData: action.payload,
        isFetchingExamResult: false
      }
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_FAILURE:
      return {
        ...state,
        isFetchingExamResult: false,
        errorFetchingExamResult: action.payload,
      };
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_RESULT_WARNING:
      return {
        ...state,
        isFetchingExamResult: false,
        onlineExamResultWarning: action.payload,
      };
    //Get Exam Detail By ID
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_DETAIL_START:
      return {
        ...state,
        isFetchingExamDetail: true,
        errorFetchingExamDetail: null,
        //reset Exam props
        onlineExamData: [],
        offset: 1,
        isLoadMore: false,
        //reset result props
        resultData: [],
        resultOffset: 1,
        resultLoadMore: false,
        counter: undefined
      };
    case OnlineExamActionTypes.SET_EXAM_COUNTER:
      return {
        ...state,
        counter: action.payload,
      };
    case OnlineExamActionTypes.SET_ONLINE_EXAM:
      let cacheData = undefined;
      try {
        if (parseInt(action.payload) === parseInt(state.currentExamID)) {
          cacheData = { ...state.onlineExamDetailData }
        }
      } catch (error) {
        cacheData = undefined;
      }
      return {
        ...state,
        isFetchingPostExam: false,
        onlineExamDetailData: cacheData,
        currentExamID: action.payload === -1 ? 0 : state.currentExamID
      };
    case OnlineExamActionTypes.SET_CURRENT_QUESTION_INDEX:
      return {
        ...state,
        currentQuestionIndex: action.payload,
      };
    case OnlineExamActionTypes.SET_EXAM_MODE:
      return {
        ...state,
        examMode: action.payload,
      };

    case OnlineExamActionTypes.SET_UPLOADING_FILE:
      return {
        ...state,
        isUploadingFile: action.payload,
      };
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_DETAIL_SUCCESS:
      const { examData, examID } = action.payload;
      const counter = examData.examDuration * 60;
      const isRandomizeQuestion = examData.isRandomizeQuestion;
      const isRandomizeAnswer = examData.isRandomizeAnswer;
      let examDetail = { ...examData }
      // When both flags were true, the old code re-assigned questionList from the
      // original API payload here and overwrote shuffled questions. Build one list.
      if (isRandomizeQuestion || isRandomizeAnswer) {
        let questionList = [...(examData.questionList || [])];
        if (isRandomizeQuestion) {
          questionList.sort(() => 0.5 - Math.random());
        }
        if (isRandomizeAnswer) {
          questionList = questionList.map((q) => ({
            ...q,
            onlineExamQuestionAnswers: [...(q.onlineExamQuestionAnswers || [])].sort(
              () => 0.5 - Math.random()
            ),
          }));
        }
        examDetail = { ...examDetail, questionList };
      }

      return {
        ...state,
        onlineExamDetailData:isExistExamData(state,examData,examID)?{ ...state.onlineExamDetailData } : examDetail,
        currentQuestionIndex: isExistExamData(state,examData,examID) ? state.currentQuestionIndex : 0,
        currentExamID: examID,
        isFetchingExamDetail: false,
        counter
      }
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_DETAIL_FAILURE:
      return {
        ...state,
        isFetchingExamDetail: false,
        errorFetchingExamDetail: action.payload,
      };
    //Get Exam Answer By ID
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_ANSWER_START:
      return {
        ...state,
        isFetchingExamAnswer: true,
        errorFetchingExamAnswer: null
      };
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_ANSWER_SUCCESS:

      return {
        ...state,
        // onlineExamDetailData: action.payload,
        isFetchingExamAnswer: false
      }
    case OnlineExamActionTypes.FETCH_ONLINEEXAM_ANSWER_FAILURE:
      return {
        ...state,
        isFetchingExamAnswer: false,
      };
    //Post Exam
    case OnlineExamActionTypes.FETCH_POST_EXAM_START:
      return {
        ...state,
        isFetchingPostExam: true,
      };
    case OnlineExamActionTypes.FETCH_POST_EXAM_SUCCESS:

      return {
        ...state,
        isFetchingPostExam: false,
        onlineExamDetailData: undefined,
        currentExamID: 0,
        currentQuestionIndex: 0
      }
    case OnlineExamActionTypes.FETCH_POST_EXAM_FAILURE:
      return {
        ...state,
        isFetchingPostExam: false,
        errorFetchingPostExam: action.payload,
      };

    //Get Results
    case OnlineExamActionTypes.FETCH_RESULTS_START:
      return {
        ...state,
        isFetchingResults: true,
        errorFetchingResults: null,
        counter: undefined
      };
    case OnlineExamActionTypes.RESET_RESULTS_LOADMORE:
      return {
        ...state,
        resultLoadMore: true,
      };
    case OnlineExamActionTypes.FETCH_RESULTS_SUCCESS:
      let resultList = [];
      if (state.resultOffset !== 1) {
        const newList = action.payload.filter(item => state.resultData.findIndex(obj => parseInt(obj.id) == parseInt(item.id)) === -1);
        resultList = [...state.resultData, ...newList]
      } else {
        resultList = action.payload
      }
      const offsetIsLoadMore = action.payload.length >= PAGE_SIZE;
      return {
        ...state,
        resultData: resultList,
        resultOffset: offsetIsLoadMore ? state.resultOffset + 1 : state.resultOffset,
        resultLoadMore: offsetIsLoadMore,
        isFetchingResults: false,
        counter: undefined,
        examMode: ExamMode.simple,
      }

    case OnlineExamActionTypes.FETCH_RESULTS_FAILURE:
      return {
        ...state,
        isFetchingResults: false,
        errorFetchingResults: action.payload,
      };

    case OnlineExamActionTypes.RESET_RESULTS_STATE:
      return {
        ...INITAIL_STATE,

      };
    case OnlineExamActionTypes.SET_SHOW_NEXT_QUESTION:
      return {
        ...state,
        showNextQuestion: action.payload
      };
    //set Answer
    case OnlineExamActionTypes.SET_ANSWER:
      const { questionId, answerObject } = action.payload;
      const onlineExamData = { ...state.onlineExamDetailData };
      const questionIndex = onlineExamData.questionList.findIndex(
        (item) => String(item.id) === String(questionId)
      );
      if (questionIndex < 0) {
        return state;
      }
      //Fill isAnswered Flag(Base on ExamType...answerId : MultipleChoicesExam | answerText or attachmentList or formula for AnotherExamTypes )
      onlineExamData.questionList[questionIndex].answered = (answerObject.answerId !== undefined && answerObject.answerId !== null) ? answerObject.answerId : answerObject.answerText || answerObject.attachmentList || answerObject.formula;

      if (answerObject.answerId !== undefined && answerObject.answerId !== null) {
        //Multiple Choice Exam
        onlineExamData.questionList[questionIndex].onlineExamQuestionAnswers.map((answer, index) => {
          if (answer.id === answerObject.answerId) {
            answer.isChoosed = true
          } else {
            answer.isChoosed = false
          }
        })
      } else {
        //Another ExamTypes
        onlineExamData.questionList[questionIndex].answerText = answerObject.answerText;
        onlineExamData.questionList[questionIndex].formulaText = answerObject.formula;
        onlineExamData.questionList[questionIndex].attachmentList = answerObject.attachmentList;
      }

      const data = { ...state.onlineExamDetailData, ...onlineExamData };
      return {
        ...state,
        onlineExamDetailData: data
      };
    //reset error
    case OnlineExamActionTypes.RESET_ERROR:

      return {
        ...state,
        errorFetchingPostExam: null
      };

    //set Current Page
    case OnlineExamActionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    default:
      return state;
  }
};

export default onlineExamReducer;
